export abstract class Request {
  static readonly POSITIONS_PER_PAGE: number = 100;
}
